module.exports = __webpack_public_path__ + "static/media/proj9_img3.755de3ec.jpg";